/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
var EditPostSettings = createContext({});
export default EditPostSettings;
//# sourceMappingURL=index.js.map